const features = [
  {
    icon: "ri-flashlight-line",
    title: "Faster Research",
    description:
      "Accelerate your product discovery process with structured spreadsheet data that eliminates hours of manual browsing across multiple platforms.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Reduced Risk",
    description:
      "Minimize sourcing mistakes by evaluating products against real market data before committing your budget to unverified opportunities.",
  },
  {
    icon: "ri-line-chart-line",
    title: "Trend Detection",
    description:
      "Spot emerging market trends early with regularly updated data that reveals shifting consumer preferences and demand patterns.",
  },
  {
    icon: "ri-scales-3-line",
    title: "Clear Comparison",
    description:
      "Compare multiple products side by side with consistent metrics, making it easy to identify the strongest candidates for your store.",
  },
  {
    icon: "ri-lightbulb-line",
    title: "Better Prediction",
    description:
      "Leverage historical pattern analysis to forecast product performance and profit potential with greater confidence.",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "Organized Intelligence",
    description:
      "Access all your product research in one structured format that is easy to navigate, sort, filter, and share with your team.",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-2">
          Why This System Works
        </p>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-12 leading-tight max-w-2xl">
          Why Sellers Use <br className="hidden md:block" />OOPBuy Spreadsheet System
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-white border border-background-200/70 rounded-lg p-6 md:p-7 hover:border-accent-200 transition-all group"
            >
              <div className="w-10 h-10 rounded-md bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}